import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
export default class ActivitySpace extends Model {
  static name = 'ActivitySpace'

  static versioned = true
  static isConfiguration = true
  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.NonFilmProgramming]

  static define () {
    this.concerns = [Archivable]

    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      name: {
        type: String,
        default: null,
        sortable: true
      },
      description: {
        type: String,
        default: null
      },
      capacity: {
        type: Integer,
        default: 1
      },
      displayOrder: {
        type: Integer,
        default: 999
      }
    }

    this.paginate = true
  }
}
